import { useEffect, useState } from "react"
import { Avatar, Chip, Typography } from '@mui/material'
import { BadgeCheck } from 'lucide-react'

import { resolveMediaUrl } from "../../../utils/media/resolveMediaUrl"

export function Profile({ isFullView, userData, color, bioTxtColor, fontColor }) {
    const [accentColor, setAccentColor] = useState(`#${color}` || "#ff1493")

    useEffect(() => {
        setAccentColor(`#${color}` || "#ff1493")
    }, [color, fontColor])

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                paddingBottom: isFullView ? '1.4rem' : '.2rem',
            }}
        >
            <Avatar
                alt="profile pic"
                src={resolveMediaUrl(userData?.profilePicture)}
                sx={{
                    width: '4.2rem',
                    height: '4.2rem',
                    m: '.6rem .2rem .4rem .2rem',
                }}
            />
            <div style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
            }}>
                {userData?.username && (
                    <>
                        <Chip
                            label={`@${userData.username}`}
                            size="small"
                            sx={{
                                m: '.4rem 0',
                                p: 0,
                                '&.MuiChip-root': {
                                    backgroundColor: accentColor,
                                    color: fontColor,
                                },
                                display: 'block',
                            }}
                        />
                        {userData?.verified && (
                            <BadgeCheck
                                size={30}
                                fill="#0373e2"
                                color="#fff"
                                style={{ padding: '0 .3rem' }}
                            />
                        )}
                    </>
                )}
            </div>
            {isFullView && userData?.bio && (
                <Typography
                    variant="body2"
                    component="p"
                    sx={{ mt: .5, color: bioTxtColor, fontFamily: 'Catamaran' }}
                >
                    {userData.bio}
                </Typography>
            )}
        </div>
    )
}
